import Axios from '@/services/axios-instance/axios.service';

class UserService {
  async loginUser(req) {
    const { data } = await Axios.post('/login', req);
    return data;
  }
  async loginUserAsAdmin(req) {
    const { data } = await Axios.post('/login-as-admin', req);
    return data;
  }
  async forgotUserPassword(req) {
    const { data } = await Axios.post('/forgot-password', req);
    return data;
  }
  async logoutUser() {
    const { data } = await Axios.get('/logout');
    return data;
  }
}

export default new UserService();
